import script from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFooter.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFooter.vue?vue&type=style&index=0&id=26f87eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f87eea"]])

export default __exports__